import { generateId } from "../../../utils";

export const normalTextElement = { type: 'p', children: [{ text: '' }] }

export const getNormalTextElement = () => {
  return { type: 'p', id: generateId(), children: [{ text: '' }] }
}